// Aba DOCUMENTOS (Editar Usuário) — documentos reais do cliente (contrato,
// RG/CNH, comprovante de residência/renda etc), via GPS Drive Backend
// (nunca localStorage). Primeiro real desta aba (2026-08-27), antes um
// upload/lista 100% de mentira. Mesmo padrão de gpsdrive-billing.service.ts.
import { gpsDriveDelete, gpsDriveGet, gpsDriveUploadWithFields } from "@/lib/api/gpsdrive-client";

export type ClientDocumentCategory =
  | "contrato"
  | "documento_pessoal"
  | "comprovante_residencia"
  | "comprovante_renda"
  | "outro";

export interface ClientDocument {
  id: string;
  fileName: string;
  mimeType: string;
  sizeBytes: number;
  category: ClientDocumentCategory;
  url: string;
  createdAt: string;
}

export const gpsDriveClientDocumentsService = {
  list: (userId: string) => gpsDriveGet<ClientDocument[]>(`/api/v1/users/${userId}/documents`),
  upload: (userId: string, file: File, category: ClientDocumentCategory) =>
    gpsDriveUploadWithFields<ClientDocument>(`/api/v1/users/${userId}/documents`, file, { category }),
  remove: (userId: string, documentId: string) =>
    gpsDriveDelete<void>(`/api/v1/users/${userId}/documents/${documentId}`),
};
